import { render } from "./AppTabRoute.vue?vue&type=template&id=7b7275b8&scoped=true"
import script from "./AppTabRoute.vue?vue&type=script&lang=js"
export * from "./AppTabRoute.vue?vue&type=script&lang=js"

import "./AppTabRoute.vue?vue&type=style&index=0&id=7b7275b8&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7275b8"]])

export default __exports__